// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"957":"fa2171a476add3f3","4724":"b6323009d4472833","6325":"7587d2ee578aa640"}[chunkId] + ".css";
};